// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RdDY","title":"styles_title__1CTyS"};